export const en = {
    title: 'Early check-in and late check-out',
    description: 'The option will be added at the stage of registration of the service',
    choose_check_in: 'Choose the time of check-in...',
    choose_check_out: 'Choose the time of check-out...',
    early_check_in: 'Early check-in',
    late_check_out: 'Late check-out',
};
